/* ============================================
   HŌCHA — Shopify Theme JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ——— Hero video coax-mobile-play ——— */
  const heroVideo = document.getElementById('hero-video');
  if (heroVideo) {
    heroVideo.muted = true;
    const tryPlay = () => {
      const p = heroVideo.play();
      if (p && typeof p.then === 'function') {
        p.catch(() => {
          const resume = () => {
            heroVideo.play().catch(() => {});
            document.removeEventListener('touchstart', resume);
            document.removeEventListener('click', resume);
            document.removeEventListener('scroll', resume);
          };
          document.addEventListener('touchstart', resume, { once: true });
          document.addEventListener('click', resume, { once: true });
          document.addEventListener('scroll', resume, { once: true });
        });
      }
    };
    if (heroVideo.readyState >= 2) tryPlay();
    else heroVideo.addEventListener('loadeddata', tryPlay, { once: true });
  }

  /* ——— Nav scroll effect ——— */
  const nav = document.getElementById('site-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    });
  }

  /* ——— Reveal-on-scroll ——— */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(r => observer.observe(r));
  }

  /* ——— Waitlist form (Klaviyo or Shopify customer fallback) ——— */
  const waitlistForm = document.getElementById('waitlist-form');
  const waitlistSuccess = document.getElementById('waitlist-success');

  if (waitlistForm) {
    waitlistForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = waitlistForm.querySelector('input[name="email"]').value;
      const klaviyoListId = waitlistForm.dataset.klaviyoList;
      const klaviyoCompanyId = waitlistForm.dataset.klaviyoCompany;

      if (klaviyoListId && klaviyoCompanyId) {
        // Klaviyo client-side subscribe
        try {
          const body = new URLSearchParams();
          body.append('g', klaviyoListId);
          body.append('email', email);
          body.append('$fields', 'email');
          await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
          });
        } catch (err) { /* silent — show success regardless */ }
      } else {
        // Fallback: Shopify customer creation (no password — accept marketing only)
        try {
          const formData = new FormData();
          formData.append('form_type', 'customer');
          formData.append('utf8', '✓');
          formData.append('contact[tags]', 'newsletter,waitlist');
          formData.append('contact[email]', email);
          await fetch('/contact#contact_form', { method: 'POST', body: formData });
        } catch (err) { /* silent */ }
      }

      waitlistForm.style.display = 'none';
      if (waitlistSuccess) waitlistSuccess.classList.add('visible');
    });
  }

  /* ——— Cart drawer ——— */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-drawer-overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    refreshCart();
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('visible');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ——— Refresh cart contents from /cart.js ——— */
  async function refreshCart() {
    const itemsEl = document.getElementById('cart-drawer-items');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const countEl = document.getElementById('nav-cart-count');
    if (!itemsEl) return;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (countEl) countEl.textContent = cart.item_count;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty">your basket is empty.</div>';
        if (subtotalEl) subtotalEl.textContent = '';
        return;
      }

      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-line" data-key="${item.key}">
          <img src="${item.image}" alt="${escapeHtml(item.product_title)}">
          <div>
            <div class="cart-line-name">${escapeHtml(item.product_title)}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line-variant">${escapeHtml(item.variant_title)}</div>` : ''}
            <div class="cart-line-price">${formatMoney(item.final_line_price)} · qty ${item.quantity}</div>
            <div class="cart-line-actions">
              <button class="cart-line-remove" data-remove="${item.key}">remove</button>
            </div>
          </div>
        </div>
      `).join('');

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      itemsEl.querySelectorAll('[data-remove]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const key = btn.dataset.remove;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });
          refreshCart();
        });
      });
    } catch (err) { console.error('cart refresh failed', err); }
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'GBP';
    const symbol = { GBP: '£', USD: '$', EUR: '€' }[currency] || '';
    return symbol + (cents / 100).toFixed(2);
  }
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ——— Add to cart (product page) ——— */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      const btn = productForm.querySelector('.add-to-cart');
      const original = btn.textContent;
      btn.textContent = 'adding…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData,
        });
        if (!res.ok) throw new Error('add failed');
        btn.textContent = 'added ✓';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1200);
        openCart();
      } catch (err) {
        btn.textContent = 'sorry — try again';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2000);
      }
    });
  }

  /* ——— Variant selector ——— */
  document.querySelectorAll('.variant-options').forEach(group => {
    group.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('click', () => {
        group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');
        const hidden = document.getElementById('selected-variant');
        if (hidden) hidden.value = option.dataset.variantId;
        const price = document.getElementById('product-price');
        if (price && option.dataset.variantPrice) price.textContent = option.dataset.variantPrice;
      });
    });
  });

  /* ——— Quantity selector ——— */
  document.querySelectorAll('.qty-selector').forEach(sel => {
    const input = sel.querySelector('input');
    sel.querySelector('.qty-minus')?.addEventListener('click', () => {
      const n = parseInt(input.value, 10);
      if (n > 1) input.value = n - 1;
    });
    sel.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ——— Product gallery thumbnails ——— */
  document.querySelectorAll('.product-thumbs button').forEach(btn => {
    btn.addEventListener('click', () => {
      const main = document.querySelector('.product-gallery-main img');
      if (!main) return;
      const newSrc = btn.querySelector('img')?.src;
      if (newSrc) main.src = newSrc;
      document.querySelectorAll('.product-thumbs button').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ——— Initial cart count refresh ——— */
  refreshCart();
});
